import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from './types'

// The policy service sources the subscriberId (Rx ID) server-side (never in the
// URL).
//
// `groupNumber` (Rx Group) is passed FROM the SPA: it isn't PHI, and the SPA
// already has it (from the plan that feeds the on-screen card), so passing it
// here spares the policy service an extra call to source it. It's omitted when
// absent, so a member without one simply gets a card without the Rx Group row.
export const fetchMemberIdCard = (memberUuid, groupNumber = null) => {
  const query = groupNumber
    ? `?${new URLSearchParams({ groupNumber }).toString()}`
    : ''

  return {
    [RSAA]: {
      endpoint: getApiPath(
        'plcy',
        `members/${memberUuid}/id-card/download${query}`,
      ),
      method: 'GET',
      types: [
        types.FETCH_MEMBER_ID_CARD_REQUEST,
        types.FETCH_MEMBER_ID_CARD_SUCCESS,
        types.FETCH_MEMBER_ID_CARD_ERROR,
      ],
    },
  }
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_MEMBER_ID_CARD_REQUEST: {
      return {
        ...state,
        memberIdCard: {
          ...state.memberIdCard,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_MEMBER_ID_CARD_SUCCESS: {
      return {
        ...state,
        memberIdCard: {
          ...state.memberIdCard,
          busy: false,
          entity: payload?.url,
        },
      }
    }

    case types.FETCH_MEMBER_ID_CARD_ERROR: {
      return {
        ...state,
        memberIdCard: {
          ...state.memberIdCard,
          busy: false,
          error: R.pathOr(
            'Something went wrong',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }
    // ----------

    default:
      return state
  }
}
